"use strict";

{
  const fvSwiperEl = document.querySelector(".p-fv__swiper");
  const playBtn = document.querySelector(".js-fv-play-btn");

  if (fvSwiperEl) {
    // Swiperの初期化
    const fvSwiper = new Swiper(fvSwiperEl, {
      loop: true,
      effect: "fade", // フェード切り替え
      speed: 2000, // 切り替え速度
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 4000, // 待機時間
        disableOnInteraction: false, // ユーザー操作後も自動再生を続ける
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      on: {
        // 初期化時や自動再生の状態変化時にボタンの見た目を更新
        init: function (swiper) {
          updatePlayBtn(swiper);
        },
        autoplayStart: function (swiper) {
          updatePlayBtn(swiper);
        },
        autoplayStop: function (swiper) {
          updatePlayBtn(swiper);
        },
      },
    });

    // ボタンクリック時の処理
    if (playBtn) {
      playBtn.addEventListener("click", () => {
        if (fvSwiper.autoplay.running) {
          fvSwiper.autoplay.stop();
        } else {
          fvSwiper.autoplay.start();
        }
      });
    }

    function updatePlayBtn(swiper) {
      if (!playBtn) return;
      if (swiper.autoplay.running) {
        playBtn.classList.add("is-playing");
      } else {
        playBtn.classList.remove("is-playing");
      }
    }
  }
}
